export default {
    campaignList: [],
    campaignListCount: 0,
    campaign: {},
}